import http from "@/plugins/Axios";

export default {
  actions: {
    async getRoles(_, query) {
      try {
        const {
          data: { data },
        } = await http.get("role/list", {
          params: {
            page: query && query.page - 1,
            limit: query && query.limit,
          },
        });
        return { data };
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
